import { defineStore } from "pinia";

import { store } from "@/store";
import { useChannelStoreHook } from "@/store/modules/channel";
import { useHttpStoreHook } from "@/store/modules/http";

import { getChannelKeyByHost } from "../config";

export const useYChannelStore = defineStore({
  id: "y-channel",
  state: () => ({
    channel: null
  }),
  actions: {
    async init() {
      const channelKey = getChannelKeyByHost();
      this.channel = channelKey;
      useHttpStoreHook().setHeader('y-platform-channel', channelKey)
      await useChannelStoreHook().getChannel(channelKey);
    }
  }
});

export function useYChannelStoreHook() {
  return useYChannelStore(store);
}
